import { DropzoneUploader } from './DropzoneUploader';
export default DropzoneUploader;
